import { observable } from "mobx";
import { Type } from "class-transformer";
import DomesticBankAccountResponse from "./domesticBankAccountResponse";
import InternalTransferApprovalResponse from "./internalTransferApprovalResponse";
import type { IApprovable } from "./types";
import type InternalTransferApprovalType from "./internalTransferApprovalType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class InternalTransferResponse implements IApprovable<InternalTransferApprovalType> {
  id!: string;

  @observable
  month!: number;

  @observable
  year!: number;

  @observable
  @Type(() => DomesticBankAccountResponse)
  senderBankAccount!: DomesticBankAccountResponse;

  @observable
  @Type(() => DomesticBankAccountResponse)
  recipientBankAccount!: DomesticBankAccountResponse;

  @observable
  messageForRecipient?: string;

  @observable
  amount!: number;

  @observable
  variableSymbol!: number;

  @observable
  constantSymbol!: number;

  @observable
  specificSymbol!: number;

  @observable
  isExported!: boolean;

  @observable
  isValidForApproval!: boolean;

  @observable
  @Type(() => InternalTransferApprovalResponse)
  approvals!: InternalTransferApprovalResponse[];
}
